@if (formData.businessType() === 'individual') {
  <app-individual-form [form]="form" />
}
@if (formData.businessType() === 'company') {
  <app-company-form [form]="form" />
}
@if (formData.businessType() === 'cooperative') {
  <app-cooperative-form [form]="form" />
}
